import React from 'react';
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import { Modal, Button, Row, Col, DatePicker, Select, InputNumber, message } from 'antd';
import {
    dispensaries as dispensaryServices
} from '../../../services';
import ManualVolumeRegisterDrawer from './ManualVolumeRegistrerDrawer';
const { Option } = Select;

const ManualVolumeRegisterForm = Form.create({ name: 'jsonShowInfo_into_modal' })(

    class extends React.Component {
        state = {
            reportsInfo: [],
            visible: false,
        };

        showModal = () => {
            this.setState({
                visible: true,
            });
        }

        handleReturn = () => {
            this.setState({
                visible: false,
            });
            this.props.form.resetFields();
            this.props.fetchVolumeMeasurerRegistries();
        };

        render() {
            const { getFieldDecorator } = this.props.form;
            const optionIdEquipment = types => types.map(item => (
                <Option key={item.idEquipment} value={item.idEquipment}>{item.auditableEquipmentKey}</Option>
            ));

            return (
                <div>
                    <Button type="primary" icon={<DownloadOutlined />} onClick={() => this.showModal()}>Insertar registro de volumen a tanque</Button>
                    <ManualVolumeRegisterDrawer
                        isVisible={this.state.visible}
                        onClose={this.handleReturn}
                        measurementEquipments={this.props.measurementEquipments}
                    />
                </div>
            );
        }
    }
);

export default ManualVolumeRegisterForm;
